
export default {
  name: "FieldErrors",
  props: { errors: Array },
};
